{
  "enum": {
    "IxcDtccDtcV1AssetDayStatus": {
      "BLOCKED": "Blocked",
      "BREAK": "Break",
      "CURRENT": "Current",
      "RECONCILED": "Reconciled",
      "UNSPECIFIED": "Unspecified"
    }
  },
  "filterEnum": {
    "IxcDtccDtcV1AssetDayQueryServiceAssetDayListFilterableFields": {
      "assetId": "Asset",
      "data": {
        "security": {
          "cusip": "CUSIP"
        }
      },
      "date": "Date",
      "status": "Status"
    }
  },
  "oneOf": {
    "IxcDtccDtcV1AssetDayEventType": {
      "apiBal": "APIBal",
      "break": "Break",
      "cnsPosted": "CNS Posted",
      "dtcCorporateActionPayment": "DTC Corporate Action Payment",
      "open": "Open",
      "openingFigures": "Opening Figures",
      "ragl": "RAGL",
      "reconcile": "Reconcile",
      "reconciled": "Reconciled"
    }
  },
  "searchEnum": {
    "IxcDtccDtcV1AssetDayQueryServiceAssetDayListSearchableFields": {
      "data": {
        "security": {
          "name": "Data Security Name",
          "symbol": {
            "base": "Data Security Symbol Base"
          }
        }
      }
    }
  },
  "sortEnum": {
    "IxcDtccDtcV1AssetDayQueryServiceAssetDayListSortableFields": {
      "date": "Date",
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    }
  }
}